/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';
import { restructureTaskAsOwnerModel } from '../../TasksService/restructuring';
import { restructureExecMaterialsModel } from '../../TasksExecsMaterials/restructuring';

export function restructureExecLogModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    ip: lc.get(data, 'ip'),
    taskExecId: lc.get(data, 'task_exec_id'),
    userId: lc.get(data, 'user_id'),
    materials: !_.isEmpty(lc.get(data, 'data'))
      ? lc
          .get(data, 'materials')
          .map(item => restructureExecMaterialsModel(state, item))
      : [],
    data: !_.isEmpty(lc.get(data, 'data')) ? lc.get(data, 'data') : {},
    eventType: lc.get(data, 'event_type'),
    eventTypeDesc: lc.get(data, 'event_type_desc'),
    execUserAvatar: lc.get(data, 'exec_user_avatar'),
    execUserName: lc.get(data, 'exec_user_name'),
    execUserRole: lc.get(data, 'exec_user_role'),
    createdAt: lc.get(data, 'created_at')
  };
}

export function restructureTaskExecModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    taskId: lc.get(data, 'task_id'),
    ownerId: lc.get(data, 'user_id'),
    ownerName: _.get(data, 'owner.profile.name'),
    ownerAvatarPath: _.get(data, 'owner.profile.avatar_path'),
    taskOwnerId: lc.get(data, 'task_owner_id'),
    execModeratorId: lc.get(data, 'exec_moderator_id'),
    status: lc.get(data, 'status'),
    statusTime: lc.get(data, 'status_time'),
    sum: lc.get(data, 'sum'),
    cost: lc.get(data, 'cost'),
    timePerform: lc.get(data, 'time_perform'),
    timeChecking: lc.get(data, 'time_checking'),
    quizAsk: lc.get(data, 'quiz_ask'),
    quizAnswerLog: lc.get(data, 'quiz_answer_log'),
    quizAttempts: lc.get(data, 'quiz_attempts'),
    taskLink: lc.get(data, 'task_link'),
    taskExecNum: lc.get(data, 'task_exec_num'),
    checkType: lc.get(data, 'check_type'),
    // deadlineTime: lc.get(data, 'deadline_perform_time'),
    // deadlineTime: lc.get(data, 'deadline_checked_time'),
    deadlinePerformTime: lc.get(data, 'deadline_perform_time'),
    deadlinePerformTimer: lc.get(data, 'deadline_perform_timer'),
    deadlineCheckedTime: lc.get(data, 'deadline_checked_time'),
    deadlineCheckedTimer: _.get(data, 'deadline_checked_timer'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at'),
    statusName: lc.get(data, 'status_name'),
    toLeftTime: lc.get(data, 'to_left_time'),
    startTimeDesc: lc.get(data, 'start_time_desc'),
    deadlineTimeDesc: _.get(data, 'deadline_time_desc'),
    timePerformDesc: lc.get(data, 'time_perform_desc'),
    timeCheckingDesc: lc.get(data, 'time_checking_desc'),
    abilityToCancel: lc.get(data, 'ability_to_cancel'),
    sequence_number_by_user: lc.get(data, 'sequence_number_by_user'),
    lastExecLog: _.get(data, 'last_exec_log')
      ? restructureExecLogModel(state, lc.get(data, 'last_exec_log'))
      : null,
    task: _.get(data, 'task')
      ? restructureTaskAsOwnerModel(state, lc.get(data, 'task'))
      : null
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksExecsService/restructuring/index.js